import React from "react";
import { arrowIcon } from "../../common/imagePath";
import { cn } from "../../lib/utils";

const ListItem = ({ label, onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full flex items-center justify-between",
        "px-4 py-[17px]",
        "border-b border-[#E5E5EA] dark:border-[#2C2C2E]",
        "last:border-b-0",
        "bg-white dark:bg-[#1C1C1E]",
        //  "hover:bg-[#F2F2F7]  dark:hover:bg-[#2C2C2E]",

        // "active:bg-[#F2F2F7] dark:active:bg-[#2C2C2E]",
        "transition-colors duration-200",
        className,
      )}
    >
      <span
        className="
        font-semibold text-xs lg:text-sm text-left
        text-black dark:text-white
        transition-colors duration-200 font-inter
      "
      >
        {label}
      </span>

      <img
        src={arrowIcon}
        alt=""
        className="w-5 h-5 shrink-0 text-black dark:text-white transition-colors duration-200"
      />
    </button>
  );
};

export default ListItem;
